import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import './Comprobantes.css';

import ComprobantesList from './list/ComprobantesList';
import ComprobantesSearch from './list/components/ComprobantesSearch';
import ComprobantesTypeFilter from './list/components/ComprobantesTypeFilter';
import ComprobantesItemActions from './list/components/ComprobantesItemActions';
import ComprobantesToolbarActions from './list/components/ComprobantesToolbarActions';

class Comprobantes extends Component {
  state = {
    selectable: false,
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Comprobantes');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowClick = (data) => {
    this.props.history.push({
      pathname: `/ext/receptores/facturas/${data.uuid}/info`,
      state: {
        data: {
          ...data,
        },
      },
    });
  };

  handleOnToggleSelectableTableItems = () => {
    this.setState({
      selectable: !this.state.selectable,
    });
  };

  render() {
    const { selectable, selectedRowKeys, selectedRows } = this.state;

    return (
      <div className="comprobantes">
        <Row>
          <Col
            sm="auto"
            md="9"
            className="mb-2"
          >
            <div>
              {selectedRowKeys.length > 0 && (
                <div className="mr-3 d-inline-flex pb-2">
                  <ComprobantesItemActions
                    selectedRowKeys={selectedRowKeys}
                    selectedRows={selectedRows}
                  />
                </div>
              )}

              {selectedRowKeys.length === 0 && <ComprobantesSearch />}
            </div>
          </Col>

          <Col
            md="3"
            className="text-right"
          >
            <ComprobantesToolbarActions onToggleSelectableItems={this.handleOnToggleSelectableTableItems} />
          </Col>
        </Row>

        <ComprobantesTypeFilter />

        <ComprobantesList
          selectable={selectable}
          onRowClick={this.handleOnRowClick}
          onRowSelectionChange={this.handleOnRowSelectionChange}
        />
      </div>
    );
  }
}

export default Comprobantes;
